export default theme => ({
  header: {
    height: '80px',
    color: theme.palette.text.secondary,
    fontSize: '20px'
  }
});